import R from 'ramda'
import * as page from './page'

import {
  AUTH_API_URL,
  PAGES
} from '../constants'

const statePath = ['pages', PAGES.LICENSES]

export const create = ({
  payload = {}
}) => page.createOne({payload, statePath})

export const patch = ({
  licenseId,
  payload = {}
}) => page.modifyOne({
  statePath,
  _id: licenseId,
  payload
})

export const fetch = ({
  licenseId
}) => page.fetchOne({
  statePath,
  _id: licenseId
})

export const fetchList = ({
  pageNum = 1,
  perPage = 20,
  ids = null,
  showExpired = false,
  filter = 'all'
}) => page.fetchList({
  statePath,
  query: {pageNum, perPage, ids, showExpired, filter}
})

export const fetchAutocompleteSuggestions = ({term, pageNum}) => page.fetchAutocompleteSuggestions({
  statePath,
  term,
  pageNum
})

export const setAutocompleteSelections = (selections) => page.setAutocompleteSelections({
  statePath,
  selections
})

export const clearAutocompleteSuggestions = () => page.clearAutocompleteSuggestions({
  statePath
})

export const reactivateLicense = (licenseId) =>
  R.merge(page.parts.patchOne, {
    url: `${AUTH_API_URL}/licenses/${licenseId}/reactivate`,
    statePath,
    _id: licenseId
  })

export const removeLicense = ({
  licenseId
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/licenses/${licenseId}`,
  statePath,
  _id: licenseId
})

export const addSublicense = ({
  licenseId,
  payload
}) => R.merge(page.parts.postOne, {
  url: `${AUTH_API_URL}/licenses/${licenseId}/sublicenses`,
  statePath,
  _id: licenseId,
  payload
});

export const removeSublicense = ({
  licenseId,
  sublicenseId
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/licenses/${licenseId}/sublicenses/${sublicenseId}`,
  statePath,
  _id: licenseId
});

export const removeLicenseMachine = ({
  licenseId,
  machineId
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/licenses/${licenseId}/machines/${machineId}`,
  statePath,
  _id: licenseId
})

export const deactivateLicenseUpgrade = ({
  licenseId,
  licenseUpgradeId,
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/licenses/${licenseId}/downgrade/${licenseUpgradeId}`,
  statePath,
  _id: licenseId,
})



// WEBPACK FOOTER //
// ./webAdmin/actions/licenses.js